export default (theme) => ({
  h1: {
    fontSize: 34,
    fontWeight: 600,
    marginBottom: 20,
  },
  h2: {
    fontSize: 28,
    fontWeight: 500,
    paddingBottom: 4,
    borderBottom: `1px solid ${
      theme.palette.type === "dark"
        ? "rgba(255,255,255,0.4)"
        : "rgba(0,0,0,0.4)"
    }`,
    width: "100%",
    display: "block",
    marginBottom: 20,
    marginTop: 0,
  },
  h3: {
    fontSize: 26,
    marginBottom: 20,
    marginTop: 20,
  },
  h4: {
    fontSize: 22,
    marginBottom: 20,
    marginTop: 20,
  },
  h5: {
    fontSize: 18,
    marginBottom: 20,
    marginTop: 20,
  },
  h6: {
    fontSize: 16,
    color: theme.palette.text,
    marginBottom: 20,
    marginTop: 20,
  },
});
